
import React, { useState } from "react";
import {
  AppBar,
  Box,
  Button,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography,
  Toolbar,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import TrainingModal from "../components/TrainingModal";
import { Link } from "react-router-dom";

const Navigation = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = useState(false);
  const menuItems = ["HOME", "FREE DEMO", "PRIVACY POLICY"];

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <>
      <AppBar position="fixed" color="transparent" elevation={0}>
        <Toolbar>
          
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }} >
            KALISUNMARKETING.COM
          </Link>
          </Typography>
          {/* <Box sx={{ flexGrow: 1 }}>
          <img
            src="/logo.png" // Replace 'logo.png' with your actual logo file name
            alt="Logo"
            style={{ height: '200px' }} // Adjust height or other styles as needed
          />
        </Box> */}

          {isMobile ? (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
            >
              <MenuIcon />
            </IconButton>
          ) : (
            <Box sx={{ display: "flex", gap: 3 }}>
              {menuItems.map((item) => (
                <Button color="inherit" key={item}>
                  <>
                    {item === "FREE DEMO" ? (
                      <span onClick={() => setOpen(true)}>{item}</span>
                    ) : (
                      <Link to={item === "PRIVACY POLICY" ? "/privacy-policy" : "/"} style={{ textDecoration: 'none', color: 'inherit' }}>{item}</Link>
                    )}
                  </>
                </Button>
              ))}
            </Box>
          )}
          <TrainingModal open={open} onClose={() => setOpen(false)} />
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
      >
        <Box sx={{ width: 250, bgcolor: "background.paper", height: "100%" }}>
          <IconButton onClick={handleDrawerToggle} sx={{ m: 1 }}>
            <CloseIcon />
          </IconButton>
          <List>
            {menuItems.map((item) => (
              <ListItem button key={item}>
                {item === "FREE DEMO" ? (
                  <ListItemText onClick={() => setOpen(true)} primary={item} />
                ) : ( 
                  <Link to={item === "PRIVACY POLICY" ? "/privacy-policy" : "/"} style={{ textDecoration: 'none', color: 'inherit' }}>
                    <ListItemText primary={item} />
                  </Link>
                )}
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
    </>
  );
};
export default Navigation;